import { Clock } from "../components/Clock"
import { ModalWrapper, Clue } from "src/utils/fw"

export default {
	backgroundFunction: () => [
			["2021-11-01T08:00+00:00", "https://assets.swoogo.com/uploads/full/1462698-6189a6f9be172.jpg"],
			["2021-11-17T08:00+00:00", "https://assets.swoogo.com/uploads/full/1464364-618ab99875145.jpg"],
			["2021-11-17T16:30+00:00", "https://assets.swoogo.com/uploads/full/1464361-618ab9982793e.jpg"],
			["2021-11-17T22:00+00:00", "https://assets.swoogo.com/uploads/full/1464365-618ab998873bc.jpg"],
			["2021-11-18T08:00+00:00", "https://assets.swoogo.com/uploads/full/1464362-618ab9984713c.jpg"],
			["2021-11-18T16:30+00:00", "https://assets.swoogo.com/uploads/full/1464363-618ab9984df1d.jpg"],
		].sort((a, b) => a[0] < b[0] ? 1 : -1).find(i => new Date(i[0]) < new Date())[1]
	,
	extras: (
		<>
			<iframe
				className="auditorium-livestream"
				src="https://embedplayer.evia.events/tkeventsmainstage?autoplay=true&muted=false"
				allowfullscreen
			/>
			<Clock />
		</>
	),
	links: [
		{
			label: "To Lobby",
			href: "/lobby",
			width: "18.5%",
			height: "14.4%",
			left: "40.3%",
			top: "84.9%",
		},
		// {
		// 	label: "APAC Agenda",
		// 	width: "14.1%",
		// 	height: "39.4%",
		// 	left: "75.9%",
		// 	top: "17.6%",
		// },
		{
			label: "Quadient Logo",
			width: "14.7%",
			height: "20.9%",
			left: "11%",
			top: "18.3%",
			modal: <ModalWrapper wrapperStyle={{ backgroundColor: "#7536f0" }}><Clue
				letter="&quot;E&quot;!"
			></Clue></ModalWrapper>
		},
		{
			label: "Q and A",
			CometChatID: "main-stage",
			width: "6.3%",
			height: "12.8%",
			left: "7.3%",
			top: "37.8%",
			CometChatID: "main-stage",
		},
	],
	name: "main-stage",
}
